export const EXPORT_SELECTED_CITATIONS_ID = 'export-selected-button'
export const COPY_SELECTED_CITATIONS_ID = 'copy-selected-button'
export const DELETE_SELECTED_CITATIONS_ID = 'delete-selected-button'
export const CHECKBOX_MENU_ID = 'checkbox-menu-id'
export const SELECT_ALL_CITATIONS_ID = 'select-all-citations'
export const DESELECT_ALL_CITATIONS_ID = 'deselect-all-citations'
